<template>
  <AsideMenu :tabs="tabs" :currentSlideIndex="currentSlideIndex" :hasFullWidthContent="true" />
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import AsideMenu from '@/components/AsideMenu/AsideMenu.vue'
import ADMIN_MENU_TRANSLATION from '@/locales/admin-menu.json'
import ADMIN_STATUSES_TRANSLATION from '@/locales/admin-statuses.json'
import { ACCI_API_URL } from '@/constants/route-names'
import { topLevelTabs, reportTabs } from './navigation'
import { isAdminRouteComputed } from './utils'

const TOP_LEVEL_MENU_INDEX = 0
const REPORT_MENU_INDEX = 1
const BULL_BOARD_PATH = '/admin/queues/'

export default {
  name: 'AdminMenu',
  components: {
    AsideMenu,
  },

  i18n: {
    messages: {
      en: { ...ADMIN_MENU_TRANSLATION.en, adminStatuses: ADMIN_STATUSES_TRANSLATION.en },
      fr: { ...ADMIN_MENU_TRANSLATION.fr, adminStatuses: ADMIN_STATUSES_TRANSLATION.fr },
    },
  },

  computed: {
    ...isAdminRouteComputed,

    ...mapState('admin', ['currentReport', 'lastVisitedReportsPage']),

    ...mapGetters({
      accurateRole: 'account/accurateRole',
      isSuperAdmin: 'account/isSuperAdmin',
    }),

    topLevelTabs,
    reportTabs,

    tabs() {
      const bullBoardLink = this.isSuperAdmin
        ? [
            {
              text: this.$t('queueDashboard'),
              externalLink: `${ACCI_API_URL}${BULL_BOARD_PATH}`,
            },
          ]
        : []
      return [
        [
          ...this.topLevelTabs,
          ...bullBoardLink,
          {
            text: this.$t('auth.logout'),
            events: { click: () => this.logout(this.$router) },
          },
        ],
        this.reportTabs,
      ]
    },

    currentSlideIndex() {
      return this.isAdminReportPage ? REPORT_MENU_INDEX : TOP_LEVEL_MENU_INDEX
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.isAdminReportsPage) {
          const { params, query } = this.$route
          this.setLastVisitedReportsPage({
            name: this.$route.name.replace(/___[a-z]{2}$/, ''),
            params,
            query,
          })
        }
      },
    },
  },

  methods: {
    ...mapMutations({
      setLastVisitedReportsPage: 'admin/setLastVisitedReportsPage',
    }),

    ...mapActions({
      logout: 'account/logout',
    }),
  },
}
</script>
